import { TFunction } from 'react-i18next'

import { DomainData } from '../../redux/domains'
import { FieldInterceptor } from '../../utils/validation'

export type RegisterPageConfig = {
  additionalFields: {
    name: string
    placeholder?: string
    label?: string
    type?: string
    subscriberType?: string
    domain?: string
    interceptor?: FieldInterceptor<string>
  }[]
  requiredContact?: boolean
}

export function useDefaultRegisterPageConfig(): RegisterPageConfig {
  return {
    additionalFields: []
  }
}

export type AccountingConfig = {
  displayRegistrationNumber: boolean
  displayTaxCode: boolean
  hideInvestigationFormLink?: boolean
  displayDocumentUpload?: boolean
}

export function useDefaultAccountingConfig(): AccountingConfig {
  return {
    displayRegistrationNumber: true,
    displayTaxCode: false,
    hideInvestigationFormLink: false,
    displayDocumentUpload: false
  }
}

export type DeliveryOption = {
  code: string
  currency?: string
  displayNetValue?: string
  maxInDays: number
  minInDays: number
  netValue?: number
  displayGrossValue?: string
  grossValue?: number
}

export type DeliveryOptionLabelRenderer = (
  deliveryOptionDomain: DomainData,
  deliveryOption: DeliveryOption | undefined,
  t: TFunction<any[]>
) => string

export const minMaxDayDeliveryOptionLabel: DeliveryOptionLabelRenderer = (domainCode, deliveryOption, t) =>
  `${domainCode.description} (${deliveryOption?.minInDays} ${deliveryOption?.minInDays ? '-' : ''} ${
    deliveryOption?.maxInDays
  } ${t('form:WorkingDays')})`

export const defaultDeliveryOptionLabelRenderer: DeliveryOptionLabelRenderer = (domainCode, deliveryOption, t) =>
  `${domainCode.description} (${deliveryOption?.maxInDays} ${t('form:WorkingDays')})`

export const maxDayRenderDeliveryOptionLabel: DeliveryOptionLabelRenderer = defaultDeliveryOptionLabelRenderer

export type InvestigationPageConfig = {
  renderDeliveryOptionLabel: DeliveryOptionLabelRenderer
  additionalRequiredFields?: {
    state: boolean
    city: boolean
    address?: boolean
  }
}

export function useDefaultInvestigationConfig(): InvestigationPageConfig {
  return {
    renderDeliveryOptionLabel: defaultDeliveryOptionLabelRenderer,
    additionalRequiredFields: {
      state: false,
      city: false,
      address: false
    }
  }
}
